import { render, staticRenderFns } from "./NavLanguageSelect.vue?vue&type=template&id=7aa9a181&scoped=true"
import script from "./NavLanguageSelect.vue?vue&type=script&lang=js"
export * from "./NavLanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./NavLanguageSelect.vue?vue&type=style&index=0&id=7aa9a181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa9a181",
  null
  
)

export default component.exports